import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

export const Container = styled.div<ResponsiveStyledProps>`
  padding: 4px;

  border-radius: 2px;

  background: #808fbd;

  cursor: pointer;

  ${theme.breakpoints.up("desktop")} {
    padding-block: 5px;
    padding-inline: 8px;
  }

  ${responsiveStyles}
`;

export const StyledBaseLink = styled(BaseLink)``;

export const Text = styled.div`
  color: #ffffff;
  font-weight: 700;
  font-size: 10px;
  font-family: ${fontRobotoCondensed};
  line-height: 12px;

  i {
    font-weight: 400;
    font-style: italic;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 12px;
    line-height: 14px;
  }
`;
